export function quoteBigIntFields(json: string, fields: string[]) {
  let out = json;
  for (const key of fields) {
    const re = new RegExp(`("${key}"\\s*:\\s*)(-?\\d{16,})(?=[\\s,}])`, "g");
    out = out.replace(re, `$1"$2"`);
  }
  return out;
}